const e = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      }
    ],
    name: "ApprovedPurchaseTokenAddressesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "blacklist",
        type: "address"
      }
    ],
    name: "BlacklistContractsUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "nftAddress",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "buyer",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "listingIndex",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "seller",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }
    ],
    name: "ItemBought",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "nftAddress",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "seller",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "listingIndex",
        type: "uint256"
      }
    ],
    name: "ItemCanceled",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "nftAddress",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "seller",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "listingIndex",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "startPrice",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "endPrice",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "ItemListed",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "nftAddress",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "seller",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "listingIndex",
        type: "uint256"
      }
    ],
    name: "ItemUnlisted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "nftAddress",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "seller",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "listingIndex",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "tokenAddress",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "startPrice",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "endPrice",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "duration",
        type: "uint256"
      }
    ],
    name: "ItemUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "payoutWalletAddress",
        type: "address"
      }
    ],
    name: "PlatformFeePayoutWalletAddressUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "platformFeePercent",
        type: "uint256"
      }
    ],
    name: "PlatformFeePercentUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "tokenReceipt",
        type: "address"
      }
    ],
    name: "TokenReceiptContractsUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "approvedPurchaseTokenAddresses",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sellerAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_nftAmount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_listingIndex",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_listTime",
        type: "uint256"
      }
    ],
    name: "buyAuctionItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_listingIndex",
        type: "uint256"
      }
    ],
    name: "cancelAuctionListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sellerAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_listingIndex",
        type: "uint256"
      }
    ],
    name: "getAuctionItemPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sellerAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_listingIndex",
        type: "uint256"
      }
    ],
    name: "getAuctionListing",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "seller",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "purchaseTokenAddress",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "startPrice",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "endPrice",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "listTime",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256"
          }
        ],
        internalType: "struct MarketPlace1155.AuctionListing",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_nftAmount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_startPrice",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_endPrice",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_duration",
        type: "uint256"
      }
    ],
    name: "listAuctionItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "payoutWalletAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "percentMaxValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "platformFeePercent",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address"
      },
      {
        internalType: "bool",
        name: "_isApproved",
        type: "bool"
      }
    ],
    name: "setApprovedPurchaseTokenAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_payoutWalletAddress",
        type: "address"
      }
    ],
    name: "setPlatformFeePayoutWalletAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_platformFeePercent",
        type: "uint256"
      }
    ],
    name: "setPlatformFeePercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_blacklist",
        type: "address"
      }
    ],
    name: "setupBlacklistContracts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenReceipt",
        type: "address"
      }
    ],
    name: "setupTokenReceiptContracts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_listingIndex",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_startPrice",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_endPrice",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_duration",
        type: "uint256"
      }
    ],
    name: "updateAuctionItem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  }
];
export {
  e as default
};
//# sourceMappingURL=polygon-marketplace-1155.json.js.map
